export default function () { return "<div class=\"__PREFIX__box\"><div class=\"__PREFIX__content\"><div class=\"__PREFIX__icon\"></div><div class=\"__PREFIX__text\"></div></div></div>"; }


// WEBPACK FOOTER //
// /home/rafael/www/pulltorefresh/src/_markup.pug